import React, { useState } from 'react';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import { Download, ArrowRight, Search, Menu, SearchIcon, Globe, InfoIcon, CheckIcon, XCircle, CheckCircle } from 'lucide-react';
import DomainCard from '../components/v2/DomainCard';
import IButton from '../components/v2/IButton';
import Input from '../components/v2/Input';
import Textarea from '../components/v2/TextArea';
import { Link } from 'react-router-dom';
import Faq, { faqData } from '../atoms/Faq';
import BlogSection from '../atoms/BlogPreview';
import ContactSection from '../atoms/Contact';
import useApp from '../hooks/useApp';

const API_KEY = "9ecdc030c28b4555aa44b4f76be804ee";


export const DomainValuationToolAdvert = () => {
    
    return (

        <div className='tool-advert-wrapper'>
            <div className="inner">

                <div className="section section-left">
                    <div className="section-text">
                        <Typography variant="para">Domain Valuation tool</Typography>
                        <Typography variant="h1">What’s the value of<br />your domain?</Typography>
                    </div>

                    <div className="section-controls">
                        <a href='/tool/appraisal'><Button variant="secondary">Find your Domain value</Button></a>
                    </div>
                </div>

            </div>
        </div>

    );
}


const ToolHero = () => {

    const [whoisData, setWhoisData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const findWHOIS = async () => {
        const domain = document.getElementById('whois-domain').value;
        
        if (!domain || domain.trim() === '') {
            setError('Please enter a domain name');
            return;
        }

        setLoading(true);
        setError(null);
        setWhoisData(null);

        try {
            const response = await fetch(`https://api.whoisfreaks.com/v1.0/whois?whois=live&domainName=${domain}&apiKey=${API_KEY}`);
            const data = await response.json();
            
            if (response.ok) {
                setWhoisData(data);
            } else {
                setError(data.message || 'Failed to fetch WHOIS data');
            }
        } catch (err) {
            setError('An error occurred while fetching WHOIS data');
        } finally {
            setLoading(false);
        }
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }
    
    return (
        <section className="tool-hero-wrapper">
            <div className="inner">
                <div className="hero-tabs">
                    <Link to='/tool/whois'>
                        <Typography variant="button">WHOIS Tool</Typography>
                    </Link>
                    <Link to='/tool/appraisal'>
                        <Typography variant="button">Domain Valuation Tool</Typography>
                    </Link>
                </div>
                <div className="hero-content-wrapper">
                    <div className='hero-text-content-wrapper'>
                        <div className="hero-text-wrapper">
                            <Typography variant="h1">Find WHOIS Information of a domain</Typography>
                            <Typography variant={'para'}>Find out who owns a domain name, including registration details, expiration date, and more.</Typography>
                        </div>
                        <div className="hero-controls-wrapper">
                            {/* Add buttons or controls here */}
                            <div className="find-tool">
                                <div className="find-inner">
                                    <div className="find-input">
                                        <input 
                                            autoFocus={true} 
                                            id="whois-domain" 
                                            type="text" 
                                            placeholder="Enter a domain name to search"
                                            onKeyPress={(e) => e.key === 'Enter' && findWHOIS()}
                                        />
                                    </div>
                                    <div className="find-button">
                                        <Button variant='primary' onClick={findWHOIS} disabled={loading}>
                                            {loading ? 'Searching...' : 'Search'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="hero-ft-text-wrapper">
                            <Typography variant="info">Looking for a brokering service?&nbsp;<a href='/contact'>Contact Us</a></Typography>
                        </div>
                    </div>
                </div>

                {error && (
                    <div className="hero-error">
                        <Typography variant="para" style={{color: '#ef4444'}}>{error}</Typography>
                    </div>
                )}

                {whoisData && (
                    <div className="hero-results">
                        <div className="hero-result-card">
                            <div className="left">
                                <div className="hdr">
                                    <Typography variant="p">Domain Information</Typography>
                                </div>
                                <div className="infox">
                                    <Typography variant="p">
                                        <strong>Domain:</strong> {whoisData.domain_name || 'N/A'}<br/>
                                        <strong>Status:</strong> {Array.isArray(whoisData.domain_status) ? whoisData.domain_status.join(', ') : (whoisData.domain_status || 'N/A')}<br/>
                                        <strong>Registrar:</strong> {whoisData.domain_registrar?.registrar_name || 'N/A'}
                                    </Typography>
                                </div>
                            </div>
                            <div className="right">
                                <div className="val" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {whoisData.domain_registered === 'yes' ? (
                                        <>
                                            <XCircle size={24} color="#ef4444" />
                                            <Typography variant="h2">Registered</Typography>
                                        </>
                                    ) : (
                                        <>
                                            <CheckCircle size={24} color="#10b981" />
                                            <Typography variant="h2">Available</Typography>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="hero-result-card">
                            <div className="left">
                                <div className="hdr">
                                    <Typography variant="p">Registration Details</Typography>
                                </div>
                                <div className="infox">
                                    <Typography variant="p">
                                        <strong>Created:</strong> {formatDate(whoisData.create_date)}<br/>
                                        <strong>Updated:</strong> {formatDate(whoisData.update_date)}<br/>
                                        <strong>Expires:</strong> {formatDate(whoisData.expiry_date)}
                                    </Typography>
                                </div>
                            </div>
                        </div>

                        {whoisData.registrant_contact && (
                            <div className="hero-result-card">
                                <div className="left">
                                    <div className="hdr">
                                        <Typography variant="p">Registrant Contact</Typography>
                                    </div>
                                    <div className="infox">
                                        <Typography variant="p">
                                            <strong>Organization:</strong> {whoisData.registrant_contact.company || 'N/A'}<br/>
                                            <strong>Country:</strong> {whoisData.registrant_contact.country_name || whoisData.registrant_contact.country || 'N/A'}<br/>
                                            <strong>State:</strong> {whoisData.registrant_contact.state || 'N/A'}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        )}

                        {whoisData.name_servers && whoisData.name_servers.length > 0 && (
                            <div className="hero-result-card">
                                <div className="left">
                                    <div className="hdr">
                                        <Typography variant="p">Name Servers</Typography>
                                    </div>
                                    <div className="infox">
                                        <Typography variant="p">
                                            {whoisData.name_servers.map((ns, index) => (
                                                <span key={index}>
                                                    {ns}
                                                    {index < whoisData.name_servers.length - 1 && <br/>}
                                                </span>
                                            ))}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="hero-sugg">
                            <Button onClick={() => window.location.href = '/contact'} variant="primary">
                                Interested in acquiring this domain? Contact Us
                            </Button>
                        </div>
                    </div>
                )}

                <div className='hero-footer'>
                    <div className='hero-bg-separator-new'></div>
                    <Typography variant="info">If you're looking to purchase a domain or find out who owns it, use our WHOIS search tool. Just enter the domain name to see important details like availability, owner info, registration date, and expiry date.</Typography>
                </div>

            </div>
        </section>
    );
}


/**
 * Home page component with feed
 * @returns {JSX.Element} Home page component
 */
const Tools = () => {

    const {allFaqList} = useApp();

    return (
        <>
            <ToolHero />
            <Faq data={allFaqList["tool/whois"]} />
            <DomainValuationToolAdvert />
            <ContactSection />
            <BlogSection />
        </>
    );
};

export default Tools;